import React from 'react';
import classNames from 'classnames';

import iconPickup from './iconPickup.png';
import css from './IconPickup.module.css';

/**
 * Person picking up an item — original emoji-style pickup icon for delivery UI.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} pickup icon image
 */
const IconPickup = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <img
      className={classes}
      src={iconPickup}
      alt=""
      aria-hidden="true"
      width={18}
      draggable={false}
    />
  );
};

export default IconPickup;
